import { render } from "./PageSchedules.vue?vue&type=template&id=61824a20&scoped=true"
import script from "./PageSchedules.vue?vue&type=script&lang=js"
export * from "./PageSchedules.vue?vue&type=script&lang=js"

import "./PageSchedules.vue?vue&type=style&index=0&id=61824a20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61824a20"]])

export default __exports__